"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.BindRowsWithHeaders = void 0;
var _bindRowsWithHeaders = require("./bindRowsWithHeaders");
exports.PLUGIN_KEY = _bindRowsWithHeaders.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _bindRowsWithHeaders.PLUGIN_PRIORITY;
exports.BindRowsWithHeaders = _bindRowsWithHeaders.BindRowsWithHeaders;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/bindRowsWithHeaders/index.js
// module id = 1245
// module chunks = 0